import { writable } from 'svelte/store';
import type { EnergyPurposeId } from './energy-v2-types';

export type EnergyV2Actions = {
	dashboardId: string | number;
	activePurpose: EnergyPurposeId;
	protectedDashboard: boolean;
	editMode: boolean;
	onPurposeSave: (purpose: EnergyPurposeId) => Promise<void>;
	onToggleEdit: () => void;
	onClone?: () => Promise<void>;
	onRestore?: () => Promise<void>;
	onVisualSave?: (visual: { icon: string; backgroundColor: string }) => Promise<void>;
};

export const energyV2Actions = writable<EnergyV2Actions | null>(null);
